import { render, staticRenderFns } from "./SiteRating.vue?vue&type=template&id=fd3d2c34"
import script from "./SiteRating.vue?vue&type=script&lang=js"
export * from "./SiteRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconStar: require('/opt/atlassian/pipelines/agent/build/components/icon/IconStar.vue').default})
